// extracted by mini-css-extract-plugin
export default {"studio-desc-wrapper":"studio-desc-wrapper_TZi_p"};